module.exports = __webpack_public_path__ + "img/owl.6d712441.svg";